import Immutable from 'immutable';

/**
 * Checks whether the object is an Immutable object
 * @param object - Plain JS Object or its Immutable version
 */
export function isImmutable<T>(object: T | DeepIMap<T>): object is DeepIMap<T> {
  // @ts-expect-error: some immutable types are missing
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  return Immutable.isImmutable(object);
}
